import { render } from "./BoardTemplates.vue?vue&type=template&id=5dfc0109&scoped=true&ts=true"
import script from "./BoardTemplates.vue?vue&type=script&lang=ts"
export * from "./BoardTemplates.vue?vue&type=script&lang=ts"

import "./BoardTemplates.vue?vue&type=style&index=0&id=5dfc0109&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfc0109"]])

export default __exports__